import React, { useContext } from 'react'
import { useTranslation } from "react-i18next"

import { DomainContext } from '../../domain-repository/DomainRepository'

import withLang from '../../withLang'

import { FooterWithClose } from '../../components/Footer'
import TrackingPage from '../../components/TrackingPage'
import { InfoTooltip } from '../../components/InfoTooltip'

function ReviewReservationExtrasPage(props) {
  const {
    reservationExtras,
  } = useContext(DomainContext)

  const { t } = useTranslation()

  return (
    <div>
      <div className='container'>
        <div className="row">
          <div className="col-3">
            <div onClick={() => props.history.push('/start')}>
              <img src={require(`../../assets/images/logo.png`)} alt="Guerin" className="img-fluid pt-3 pb-3" />
            </div>
          </div>
        </div>
        <div className='container-small container'>
          <div className="main-frame-resumo">
            <h2 className="title pt-4 pr-5 pl-5">{t('reservationViewIncluded')}</h2>
            <div className="board-resumo col-12 mt-3">
              {reservationExtras.map(extra => <Extra key={extra.extraID} extra={extra} />)}
            </div>
          </div>
        </div>
      </div>
      <FooterWithClose
        handleCloseClick={() => props.history.goBack()}
      />
    </div >
  )
}

export default withLang(TrackingPage(ReviewReservationExtrasPage, 61))

function Extra({ extra }) {
  const { t } = useTranslation()

  return (
    <div className="board-background d-flex align-items-center mb-1">
      <div className="ico"><img src={require("../../assets/images/ico-check.png")} alt="" /></div>
      <div className="text pl-2">
        <span className="pr-1">{t(extra.extraID + 'Name')}</span>
        <InfoTooltip id={extra.extraID} text={t(extra.extraID + 'Description')} />
      </div>
    </div>
  )
}
